import "./about.css";

export default function AboutThird() {
  return (
    <div className="main-choose-us">
        <h1>What Sets Us Apart</h1>
        <div className="choose-us-points">
            <div className="hover-container">
              <div className="hover-box">
                <div className="box-content">
                  <h2>Multi-Disciplinary Expertise</h2>
                  <p className="description">
                    Delivering excellence across construction, marketing, and technology with a unified vision.
                  </p>
                </div>
              </div>
            </div>

            <div className="hover-container">
              <div className="hover-box">
                <div className="box-content">
                  <h2>Innovation at Every Step</h2>
                  <p className="description">
                    Each project is executed with precision, ensuring lasting value and client satisfaction.
                  </p>
                </div>
              </div>
            </div>

            <div className="hover-container">
              <div className="hover-box">
                <div className="box-content">
                  <h2>Precision and Quality</h2>
                  <p className="description">
                    Driving impact through innovative strategies.
                  </p>
                </div>
              </div>
            </div>

            <div className="hover-container">
              <div className="hover-box">
                <div className="box-content">
                  <h2>Client-Centric Approach</h2>
                  <p className="description">
                    Tailored solutions focused on your goals, fostering long-term partnerships built on trust.
                  </p>
                </div>
              </div>
            </div>

            <div className="hover-container">
              <div className="hover-box">
                <div className="box-content">
                  <h2>Sustainable & Responsible Practices</h2>
                  <p className="description">
                    Committed to eco-friendly methods and ethical business practices across all ventures.
                  </p>
                </div>
              </div>
            </div>

            <div className="hover-container">
              <div className="hover-box">
                <div className="box-content">
                  <h2>Total Craftsmanship</h2>
                  <p className="description">
                    Delivering every project with precision from start to finish.
                  </p>
                </div>
              </div>
            </div>

        </div>
    </div>
  );
}
